/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';

import type { ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { GetQuizsetRankingsParams } from '../_model/getQuizsetRankingsParams';
import type { GetQuizsetRankingsSummaryParams } from '../_model/getQuizsetRankingsSummaryParams';
import type { SuccessBodyAllPeriodsQuizsetRankingSummaryRes } from '../_model/successBodyAllPeriodsQuizsetRankingSummaryRes';
import type { SuccessBodyListSearchQuizsetRes } from '../_model/successBodyListSearchQuizsetRes';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getQuizsetRankings = (
  params: GetQuizsetRankingsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListSearchQuizsetRes>(
    { url: `/quizsets/rankings`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizsetRankingsQueryKey = (
  params?: GetQuizsetRankingsParams,
) => {
  return [`/quizsets/rankings`, ...(params ? [params] : [])] as const;
};

export const getGetQuizsetRankingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetRankingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetRankings>>
  > = ({ signal }) => getQuizsetRankings(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetRankings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuizsetRankingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetRankings>>
>;
export type GetQuizsetRankingsQueryError = ErrorType<unknown>;

export function useGetQuizsetRankings<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetRankings>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetRankings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetRankings<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetRankings>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetRankings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetRankings<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizsetRankings<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizsetRankingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetQuizsetRankingsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetRankingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetRankings>>
  > = ({ signal }) => getQuizsetRankings(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetRankings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetQuizsetRankingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetRankings>>
>;
export type GetQuizsetRankingsSuspenseQueryError = ErrorType<unknown>;

export function useGetQuizsetRankingsSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetRankingsSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetRankingsSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizsetRankingsSuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankings>>,
  TError = ErrorType<unknown>,
>(
  params: GetQuizsetRankingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizsetRankingsSuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getQuizsetRankingsSummary = (
  params?: GetQuizsetRankingsSummaryParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyAllPeriodsQuizsetRankingSummaryRes>(
    { url: `/quizsets/rankings/summary`, method: 'GET', params, signal },
    options,
  );
};

export const getGetQuizsetRankingsSummaryQueryKey = (
  params?: GetQuizsetRankingsSummaryParams,
) => {
  return [`/quizsets/rankings/summary`, ...(params ? [params] : [])] as const;
};

export const getGetQuizsetRankingsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetRankingsSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
  > = ({ signal }) => getQuizsetRankingsSummary(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuizsetRankingsSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
>;
export type GetQuizsetRankingsSummaryQueryError = ErrorType<unknown>;

export function useGetQuizsetRankingsSummary<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetQuizsetRankingsSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetRankingsSummary<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
          TError,
          Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetRankingsSummary<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizsetRankingsSummary<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizsetRankingsSummaryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetQuizsetRankingsSummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuizsetRankingsSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
  > = ({ signal }) => getQuizsetRankingsSummary(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetQuizsetRankingsSummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuizsetRankingsSummary>>
>;
export type GetQuizsetRankingsSummarySuspenseQueryError = ErrorType<unknown>;

export function useGetQuizsetRankingsSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetQuizsetRankingsSummaryParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetRankingsSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuizsetRankingsSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetQuizsetRankingsSummarySuspense<
  TData = Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuizsetRankingsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuizsetRankingsSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuizsetRankingsSummarySuspenseQueryOptions(
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
